export const selectCurrentStep = (state) => state.options.currentStep;
export const selectIsRecording = (state) => state.options.isRecording;
export const selectIsRecordUploaded = (state) => state.options.isRecordUploaded;
export const selectIsAssetsUploaded = (state) => state.options.isAssetsUploaded;
export const selectIsAssetsUploadFailure = (state) =>
  state.options.isAssetsUploadFailure;
export const selectIsRecordingFinished = (state) =>
  state.options.isRecordingFinished;
export const selectWaitingCount = (state) => state.options.waitingCount;
